import { createBreakpoint } from "react-use";

const BREAKPOINTS = { 'sm': 640, 'md': 768, 'lg': 1024 };

export const useBreakpoint: () => string = createBreakpoint(BREAKPOINTS);
